/**
 * @file index.tsx
 *
 * @fileoverview Aligns content to the center.
 */

import { cva } from "class-variance-authority";
import React from "react";
import styles from "../Alignment.module.scss";

const alignedCenter = cva([styles.alignCenter], {
  variants: {
    flow: {
      row: styles.alignCenterDirectionRow,
      column: styles.alignCenterDirectionColumn,
    },
  },
  defaultVariants: {
    flow: "column",
  },
});
export interface AlignedCenterProps {
  /**
   * The content should flow veritcally or horizontally.
   *
   * @default "column"
   */
  flow?: "row" | "column";
  /**
   * The content to be displayed inside the chip element.
   *
   * @default "null"
   */
  children: React.ReactNode | string;
}

export default function AlignedCenter({
  flow = "column",
  children,
}: AlignedCenterProps) {
  return <div className={alignedCenter({ flow })}>{children}</div>;
}

export { AlignedCenter };
